module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledBear_j_normal.4f7c6a40.png";